
import React from "react";
import { 
  Users, BookOpen, DollarSign, AlertCircle, UserPlus, 
  ArrowLeft, ActivitySquare, GraduationCap, LineChart
} from "lucide-react";

// Define a type for the allowed icon names
export type IconName = 
  | "Users" 
  | "BookOpen" 
  | "DollarSign" 
  | "AlertCircle" 
  | "UserPlus" 
  | "ArrowLeft" 
  | "ActivitySquare"
  | "GraduationCap"
  | "LineChart";

// Color classes by icon type
const iconColors = {
  primary: "text-nalc-teal",
  navigation: "text-slate-600 dark:text-slate-300",
  chart: "text-blue-500 dark:text-blue-400",
  alert: "text-amber-500 dark:text-amber-400"
};

export const StatsIcons = {
  // Primary stats icons
  Users: () => <Users className={`h-5 w-5 ${iconColors.primary}`} aria-hidden="true" />,
  BookOpen: () => <BookOpen className={`h-5 w-5 ${iconColors.primary}`} aria-hidden="true" />,
  DollarSign: () => <DollarSign className={`h-5 w-5 ${iconColors.primary}`} aria-hidden="true" />,
  UserPlus: () => <UserPlus className={`h-5 w-5 ${iconColors.primary}`} aria-hidden="true" />,
  
  // Navigation icons
  ArrowLeft: () => <ArrowLeft className={`h-5 w-5 ${iconColors.navigation}`} aria-hidden="true" />,
  
  // Additional icons for other sections
  ActivitySquare: () => <ActivitySquare className={`h-5 w-5 ${iconColors.chart}`} aria-hidden="true" />,
  GraduationCap: () => <GraduationCap className={`h-5 w-5 ${iconColors.chart}`} aria-hidden="true" />,
  LineChart: () => <LineChart className={`h-5 w-5 ${iconColors.chart}`} aria-hidden="true" />,
  
  // Alert icon
  AlertCircle: () => <AlertCircle className={`h-5 w-5 ${iconColors.alert}`} aria-hidden="true" />
};

export const getIconComponent = (icon: IconName): React.ReactElement => {
  const IconComponent = StatsIcons[icon];
  return <IconComponent />;
};
